class FilterManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.elements = []
        this.reloadThrottleHandler = null
    }
    run() {
        document.querySelectorAll('[data-filter]').forEach((el) => {
            const mFilter = new Filter(el, this)
            mFilter.run()
            this.elements.push(mFilter)
        })
    }

    update() {
        const keys = new Set()
        const url = new URL(document.location)
        const searchParams = url.searchParams
        this.elements.forEach(mFilter => {
            if (!keys.has(mFilter.getName())) {
                keys.add(mFilter.getName())
                searchParams.delete(mFilter.getName())
            }

            if (mFilter.isChecked()) {
                searchParams.append(mFilter.getName(), mFilter.getValue())
            }
        })
        if(searchParams.has('page')) {
            searchParams.set('page', 1)
        }
        window.history.replaceState({}, '', `${url.pathname}?${searchParams}`);

        if (null !== this.reloadThrottleHandler) {
            clearTimeout(this.reloadThrottleHandler)
        }

        this.reloadThrottleHandler = setTimeout(() => {
            // const event = new Event('loading')
            // document.dispatchEvent(event)
            document.body.classList.add('loading')
            document.location.reload()
        }, 1000)
    }
}

class Filter {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }
    run() {
        this.el.addEventListener('change', (evt) => {
            this.changeHandler()
        })
    }
    changeHandler() {
        this.parent.update()
    }
    getName() {
        return this.el.name
    }
    isChecked() {
        return this.el.checked
    }
    getValue() {
        return this.el.value
    }
}

export default FilterManager